

import { CF2Component, registerComponent } from 'javascript/lander/runtime'

export default class CheckoutSavedMultiplePaymentsPreviewV1 extends CF2Component {

constructor(el, runtimeSel) {
super(el, runtimeSel)
}

mount() {
    Checkout.computed.paymentMethod.subscribe((payment_method) => {      
      this.current_payment_method = payment_method || { type: 'new-payment' }
      this.render()
    })
  }


    remove() {
      this.element.innerHTML = '';
    }
    render(initializeChildrenInstances = false) {
      const is_server = true;
      const current_payment_method = this.current_payment_method ?? null ;

      
      let html = '';
      {
        html += `  `
        if (current_payment_method?.type == "new-payment") {
          html += `<div class="elSelectText"> New Payment Method </div>`
        } else if (current_payment_method?.type == "payment-card") {
          html += `<div class="elSelectText"><i class="fab fa-cc-${current_payment_method?.icon}"></i><span class="elSelectTextMaskedNumber"> ${current_payment_method?.details}</span></div>`
        } else if (current_payment_method?.type == "paypal") {
          html += `<div class="elSelectText"><i class="fab fa-paypal"></i>${current_payment_method?.details}</div>`
        } else if (current_payment_method?.type == "Klarna") {
          html += `<div class="elSelectText"><svg xmlns="http://www.w3.org/2000/svg" width="78" viewBox="-67.935 -25.275 588.77 151.65"><path d="M79.7 0H57.4c0 18.3-8.4 35-23 46l-8.8 6.6 34.2 46.6h28.1L56.4 56.3C71.3 41.5 79.7 21.5 79.7 0zM0 0h22.8v99.2H0zm94.5 0H116v99.2H94.5zm210.1 28.7c-8.2 0-16 2.5-21.2 9.6v-7.7H263v68.6h20.7v-36c0-10.4 7-15.5 15.4-15.5 9 0 14.2 5.4 14.2 15.4v36.2h20.5V55.6c0-16-12.7-26.9-29.2-26.9zM181 30.6V35c-5.8-4-12.8-6.3-20.4-6.3-20 0-36.2 16.2-36.2 36.2 0 20 16.2 36.2 36.2 36.2 7.6 0 14.6-2.3 20.4-6.3v4.4h20.5V30.6zm-18.7 51.9c-10.3 0-18.6-7.9-18.6-17.6 0-9.7 8.3-17.6 18.6-17.6s18.6 7.9 18.6 17.6c0 9.7-8.3 17.6-18.6 17.6zm71-43v-8.9h-21v68.6h21.1v-32c0-10.8 11.7-16.6 19.8-16.6h.2v-20c-8.3 0-16 3.6-20.1 8.9zm164.3-8.9V35c-5.8-4-12.8-6.3-20.4-6.3-20 0-36.2 16.2-36.2 36.2 0 20 16.2 36.2 36.2 36.2 7.6 0 14.6-2.3 20.4-6.3v4.4h20.5V30.6zm-18.7 51.9c-10.3 0-18.6-7.9-18.6-17.6 0-9.7 8.3-17.6 18.6-17.6s18.6 7.9 18.6 17.6c.1 9.7-8.3 17.6-18.6 17.6zM434 32.6c0-1-.7-1.6-1.8-1.6h-1.9v5.2h.9v-1.9h1l.8 1.9h1l-.9-2.1c.6-.3.9-.8.9-1.5zm-1.8.8h-1v-1.6h1c.6 0 .9.3.9.8s-.2.8-.9.8z"></path><path d="M431.9 28.8c-2.7 0-4.9 2.2-4.9 4.9.1 2.7 2.2 4.9 4.9 4.9s4.9-2.2 4.9-4.9-2.2-4.9-4.9-4.9zm0 8.9c-2.2 0-3.9-1.8-3.9-4s1.8-4 3.9-4c2.2 0 3.9 1.8 3.9 4s-1.8 4-3.9 4zm8.1 37.2c-7.1 0-12.9 5.8-12.9 12.9 0 7.1 5.8 12.9 12.9 12.9 7.1 0 12.9-5.8 12.9-12.9 0-7.2-5.8-12.9-12.9-12.9z"></path></svg></div>`
        }

      }

      this.replaceContent(html) 

      if (initializeChildrenInstances) {
        const scopeToYggRender = this.element.querySelectorAll('[ygg-render]').length > 0;
        const options = { scopeToYggRender };
        CF2Component.hydrateTree(this.element, options);
      }
    }


}

registerComponent('CheckoutSavedMultiplePaymentsPreview/V1', CheckoutSavedMultiplePaymentsPreviewV1)
window["CheckoutSavedMultiplePaymentsPreviewV1"] = CheckoutSavedMultiplePaymentsPreviewV1

